import create from "zustand";

interface UiState {
  title: string;
  setTitle: (title: string) => void;
}

export const uiStore = create<UiState>((set) => ({
  title: "",
  setTitle: (title: string) => set({ title }),
}));
